/* The "Type" variant fieldset is hidden in custom.css, not here. This ran once at load and
   set an inline style, which Dawn discarded when it rebuilt <variant-selects> on the first
   variant change, making the option reappear. */

/**
 * add custom text for the pickup-availability on product page
 */
(function () {
  const CUSTOM_TEXT = `
    Please note: Pickup orders require one business day to prepare.<br>
    Pickups are available from 10 am – 3 pm.
  `;

  function applyCustomText(root = document) {
    const captions = root.querySelectorAll(
      "pickup-availability .pickup-availability-info p.caption",
    );

    captions.forEach((caption) => {
      if (caption.innerHTML !== CUSTOM_TEXT) {
        caption.innerHTML = CUSTOM_TEXT;
      }
    });
  }

  // pickup-availability-preview caption-large

  // Run initially
  applyCustomText();

  // Persistent observer (do NOT disconnect)
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "childList") {
        applyCustomText(mutation.target);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

/**
 * add custom text for the pickup-availability inside drawer
 */
(function () {
  const CUSTOM_TEXT = `
    Please note: Pickup orders require one business day to prepare. Pickups are available from 10 am – 3 pm.
  `;

  function updateDrawerContent() {
    const drawerContent = document.querySelector(
      "[data-store-availability-drawer-content]",
    );

    if (!drawerContent) return;

    const captions = drawerContent.querySelectorAll(
      ".pickup-availability-preview.caption-large",
    );

    captions.forEach((caption) => {
      if (!caption.innerHTML.includes("Please note")) {
        caption.innerHTML = CUSTOM_TEXT;
      }
    });
  }

  // Listen for drawer open button
  document.addEventListener("click", function (e) {
    const button = e.target.closest("#ShowPickupAvailabilityDrawer");
    if (!button) return;

    // Drawer renders async → wait a tick
    setTimeout(() => {
      updateDrawerContent();

      // Observe only drawer content (efficient)
      const drawerContent = document.querySelector(
        "[data-store-availability-drawer-content]",
      );

      if (drawerContent) {
        const observer = new MutationObserver(() => {
          updateDrawerContent();
        });

        observer.observe(drawerContent, {
          childList: true,
          subtree: true,
        });
      }
    }, 200);
  });
})();
